import { action, observable, runInAction } from 'mobx'
import BaseStore from '@store/table'
import Api from '@api/xi_feng/newCustomer'
import isEmpty from 'lodash/isEmpty'
import { message } from 'hljd'
import { getMomentTime } from '@hlj/hlj-utils'
import moment from 'moment'
import { getExportUrl } from '@util'

/**
 * TODO, 这里使用 antd table filter 做的筛选需要去掉
 * 使用 searchBar
 */
class Store extends BaseStore {
  initialMonth = moment().format('YYYY-MM')
  id
  @observable searchResult = []
  @observable type = '1'
  @observable showBox = false
  @observable customerVisible = false
  @observable uploadVisible = false
  @observable staffList = []
  // @observable $filters = {}
  // @observable $sorter = {}
  @observable detailData = {}
  @observable exportModalVisible = false // 导出列表
  @observable sourceList = [] // 客户来源
  @observable selectMonth = this.initialMonth // 导出选择的月份

  @observable initValue = {} // 传递给录入客资的组件的初始化数据
  @observable extraData = {}

  $listApi = Api.getCustomerList
  $pageSize = 20

  @action
  setStoreData = (data = []) => {
    runInAction(() => {
      data.forEach(item => {
        this[item.type] = item.value
      })
    })
  }

  $getParams = () => {
    const { date, ...rest } = this.$params

    let params = {}
    if (this.$params.searchValue) {
      if (this.$params.searchKey === '1') {
        params.user_phone = this.$params.searchValue
      } else {
        params.user_name = this.$params.searchValue
      }
    }
    if (this.$sorter.order) {
      params['sort_' + this.$sorter.field] =
        this.$sorter.order === 'ascend' ? 'asc' : 'desc'
    }

    params.look_at = this.$filters.look_at == 0 ? 0 : 1

    return {
      ...rest,
      ...params,
      date: !isEmpty(date)
        ? `${getMomentTime(date, 0)} - ${getMomentTime(date, 1)}`
        : undefined
    }
  }

  $extraOp = data => {
    this.extraData = data
  }

  @action
  getStaffList = async () => {
    const { data, success } = await Api.getStaffList()
    if (!success) {
      return
    }
    const staffList = data.map(item => {
      return {
        label: item.nick,
        value: item.id
      }
    })
    this.staffList = staffList
  }

  @observable merchant_customer_id = ''
  @action
  createCustomer = async (body, not_close) => {
    let info
    if (this.merchant_customer_id) {
      info = await Api.modifyCustomer({
        ...body,
        id: this.merchant_customer_id
      })
    } else {
      info = await Api.createCustomer(body)
    }
    const { success, data = {} } = info
    if (!success) {
      return
    }
    message.success('录入成功')
    runInAction(() => {
      this.merchant_customer_id = data.id
    })
    if (!not_close) {
      runInAction(() => {
        this.customerVisible = false
        this.merchant_customer_id = ''
      })
    }
    this.$getList(1)
  }

  @action
  resetAll = (obj, noNeed) => {
    this.$filters = {}
    this.$sorter = {}
    this.$setParams(null, noNeed)
  }

  /**
   * 客户来源列表
   */
  getSourceList = async () => {
    const { data } = await Api.sourceList()
    this.sourceList = isEmpty(data) ? [] : data
  }

  /**
   * 按月导出客资
   */
  exportCustomerByMonth = async () => {
    if (!this.selectMonth) {
      return message.warn('请选择月份')
    }

    const url = getExportUrl('/p/wedding/Admin/APICrmMerchantCustomer/export', {
      month: this.selectMonth
    })
    window.open(url)
  }
}

export default Store
